﻿import {
	Attachments,
	Drivers,
	ICreateComponentAttachments,
	PermitId,
	Permits,
	Residencies,
	Vehicles
} from "@2d-front-monorepo/permits-business";

import {JSX, useCallback, useMemo} from "react";
import {useNavigate, useParams} from "react-router";
import InvalidPermitId from "../../components/InvalidPermitId";
import UpdateAttachmentsComponent from "../../components/UpdateAttachmentsComponent";
import {reloadPermits} from "../../contexts/PermitsContext";
import {useHttpClient} from "../../hooks/useHttpClient";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

export default function UpdateDocumentation(): JSX.Element {
	const {permitId} = useParams<{ permitId: string }>() as { permitId: PermitId };
	const {permits} = usePermits();
	const navigate = useNavigate();
	const permit = Permits.find(permits, permitId);

	const initialState = useMemo<ICreateComponentAttachments>(() => ({
		attachments: {}
	}), []);

	if (permit == null) {
		return <InvalidPermitId permitId={permitId}/>;
	}

	const driver = Drivers.getValid(permits, permit.driver);
	const residency = Residencies.getValid(permits, permit.residency);
	const vehicles = useMemo(() => Vehicles.getValid(permits, permit.vehicles), [permits, permit]);
	const attachments = useMemo(() => Attachments.findExpired([driver?.entity, residency?.entity, ...(vehicles.map(x => x.entity))]), [driver, residency, vehicles]);

	const onSubmit = useCallback(async function (): Promise<void> {
		await useHttpClient().permits.submitForReview(permit.id);
		await reloadPermits();
		navigate(PrivateRoutes.permitsList);
	}, []);

	return <UpdateAttachmentsComponent attachments={attachments} onSubmit={onSubmit} initialState={initialState}/>;
}
